import {
  MEDIA_LARGE,
  MEDIA_MEDIUM,
  MEDIA_SMALL,
  MEDIA_XLARGE,
  MEDIA_XSMALL
} from 'constants/screenResolutions';

export const BEYOND_MAX_RESOLUTION = 1450;

export const TEXT_STOP_POINTS = {
  LEVEL_1: 90,
  LEVEL_2: 150,
  LEVEL_3: 200,
  LEVEL_4: 255
};

export const CARD_DIMENSION = {
  LARGE: 330,
  MEDIUM: 260,
  SMALL: 230
};

export const GAP_SIZE = {
  [BEYOND_MAX_RESOLUTION]: {
    [CARD_DIMENSION.LARGE]: 60,
    [CARD_DIMENSION.MEDIUM]: 50,
    [CARD_DIMENSION.SMALL]: 50
  },
  [MEDIA_XLARGE]: {
    [CARD_DIMENSION.LARGE]: 60,
    [CARD_DIMENSION.MEDIUM]: 30,
    [CARD_DIMENSION.SMALL]: 30
  },
  [MEDIA_LARGE]: {
    [CARD_DIMENSION.LARGE]: 60,
    [CARD_DIMENSION.MEDIUM]: 30,
    [CARD_DIMENSION.SMALL]: 30
  },
  [MEDIA_MEDIUM]: {
    [CARD_DIMENSION.LARGE]: 40,
    [CARD_DIMENSION.MEDIUM]: 40,
    [CARD_DIMENSION.SMALL]: 40
  },
  [MEDIA_SMALL]: {
    [CARD_DIMENSION.LARGE]: 40,
    [CARD_DIMENSION.MEDIUM]: 40,
    [CARD_DIMENSION.SMALL]: 40
  },
  [MEDIA_XSMALL]: {
    [CARD_DIMENSION.LARGE]: 40,
    [CARD_DIMENSION.MEDIUM]: 40,
    [CARD_DIMENSION.SMALL]: 40
  }
};

export const MARGIN_SIZE = {
  [CARD_DIMENSION.LARGE]: 30,
  [CARD_DIMENSION.MEDIUM]: 25,
  [CARD_DIMENSION.SMALL]: 20
};

export const POSITIONING = {
  LEFT: 'left-positioning',
  CENTER: 'center-positioning',
  RIGHT: 'right-positioning'
};

export enum CardSize {
  small = 'smallCard',
  medium = 'mediumCard',
  big = 'bigCard'
}

export const FlipCardsGridPositioning: any = {
  [POSITIONING.LEFT]: 'flex-start',
  [POSITIONING.CENTER]: 'center',
  [POSITIONING.RIGHT]: 'flex-end'
};

export enum CardAlignment {
  left = 'start',
  center = 'center',
  right = 'end'
}

export enum FlipCardsGrid {
  oneInTheRow = 'one-in-the-row',
  twoInTheRow = 'two-in-the-row',
  threeInTheRow = 'three-in-the-row'
}

export const CARD_DIMENSION_MAP: any = {
  [FlipCardsGrid.oneInTheRow]: CARD_DIMENSION.LARGE,
  [FlipCardsGrid.twoInTheRow]: CARD_DIMENSION.LARGE,
  [FlipCardsGrid.threeInTheRow]: CARD_DIMENSION.MEDIUM
};

export const ROW_SIZE_MAPPING: any = {
  [FlipCardsGrid.oneInTheRow]: 1,
  [FlipCardsGrid.twoInTheRow]: 2,
  [FlipCardsGrid.threeInTheRow]: 3
};

export const CARD_SIZE_MAP: any = {
  [CARD_DIMENSION.LARGE]: CardSize.big,
  [CARD_DIMENSION.MEDIUM]: CardSize.medium,
  [CARD_DIMENSION.SMALL]: CardSize.small
};

export const TEXT_COUNT_FONT_SIZES_MAP: any = {
  [TEXT_STOP_POINTS.LEVEL_1]: {
    [CardSize.big]: {
      fontSize: 24,
      lineHeight: 1.4
    },
    [CardSize.medium]: {
      fontSize: 22,
      lineHeight: 1.4
    },
    [CardSize.small]: {
      fontSize: 20,
      lineHeight: 1.4
    }
  },
  [TEXT_STOP_POINTS.LEVEL_2]: {
    [CardSize.big]: {
      fontSize: 22,
      lineHeight: 1.4
    },
    [CardSize.medium]: {
      fontSize: 18,
      lineHeight: 1.2
    },
    [CardSize.small]: {
      fontSize: 18,
      lineHeight: 1.2
    }
  },
  [TEXT_STOP_POINTS.LEVEL_3]: {
    [CardSize.big]: {
      fontSize: 20,
      lineHeight: 1.4
    },
    [CardSize.medium]: {
      fontSize: 16,
      lineHeight: 1.25
    },
    [CardSize.small]: {
      fontSize: 16,
      lineHeight: 1.25
    }
  },
  [TEXT_STOP_POINTS.LEVEL_4]: {
    [CardSize.big]: {
      fontSize: 18,
      lineHeight: 1.4
    },
    [CardSize.medium]: {
      fontSize: 16,
      lineHeight: 1.25
    },
    [CardSize.small]: {
      fontSize: 14,
      lineHeight: 1.25
    }
  }
};
